type Props = { size?: number; idSuffix?: string; saisineNumber?: string };

export function QorumSeal({ size = 110, idSuffix = "default", saisineNumber }: Props) {
  const small = size <= 80;
  const letterSize = small ? 30 : 44;
  const pathId = `seal-path-${idSuffix}`;

  return (
    <div
      data-testid="qorum-seal"
      data-rp="qorum-seal"
      role="img"
      aria-label={`Sceau du Conseil Hōjin${saisineNumber ? `, saisine ${saisineNumber}` : ""}`}
      style={{
        position: "absolute",
        top: -8,
        right: -8,
        width: size,
        height: size,
        borderRadius: "50%",
        border: "1px solid var(--qv3-gold)",
        background: "var(--qv3-paper)",
        boxShadow: "0 0 0 4px var(--qv3-paper), 0 0 0 4.5px var(--qv3-gold-tint)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <svg
        width={size}
        height={size}
        viewBox="0 0 100 100"
        style={{ position: "absolute", inset: 0 }}
        aria-hidden
      >
        <defs>
          <path
            id={pathId}
            d="M 50,50 m -42,0 a 42,42 0 1,1 84,0 a 42,42 0 1,1 -84,0"
            fill="none"
          />
        </defs>
        <text
          fill="var(--qv3-gold)"
          style={{
            fontFamily: "var(--qv3-font-mono)",
            fontSize: small ? 7 : 8,
            letterSpacing: 2.5,
          }}
        >
          <textPath href={`#${pathId}`} startOffset="0">
            Hōjin · VERDICT RENDU · MMXXVI · Hōjin · VERDICT RENDU · MMXXVI ·
          </textPath>
        </text>
      </svg>
      <span
        style={{
          position: "relative",
          display: "inline-block",
          fontFamily: "var(--qv3-font-serif)",
          fontStyle: "italic",
          fontWeight: 300,
          fontSize: letterSize,
          color: "var(--qv3-gold)",
          lineHeight: 1,
          letterSpacing: "-0.04em",
        }}
      >
        N
      </span>
    </div>
  );
}

export default QorumSeal;
